const textButtonStyles = theme => ({
  '.btn-text': {
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
  },

  '.btn-text-dark': {
    color: theme('colors.green1.55'),
    '&:hover, &:focus': {
      color: theme('colors.green1.60'),
    },

    '&:active': {
      color: theme('colors.green1.65'),
    },

    '&.disabled': {
      color: theme('colors.green1.30'),
    },
  },

  // Ensure we're also overriding default anchor element styles
  '.btn-text-dark-noicon': {
    textDecoration: `underline solid ${theme('colors.green1.55')}`,
    textDecorationThickness: '2px',
    textUnderlineOffset: '3px',
    textDecorationSkipInk: 'none',
    // textDecorationThickness is not included in height,
    // so other elements may clip the text decoration without this extra margin
    marginBottom: '1px',

    '&:hover, &:focus': {
      textDecoration: `underline solid ${theme('colors.green1.60')}`,
      textDecorationThickness: '2px',
    },

    '&:active': {
      textDecoration: `underline solid ${theme('colors.green1.65')}`,
      textDecorationThickness: '2px',
    },

    '&.disabled': {
      color: theme('colors.green1.30'),
      textDecoration: `underline solid ${theme('colors.green1.30')}`,
      textDecorationThickness: '2px',
    },
  },

  '.btn-text-light': {
    color: theme('colors.green1.10'),

    '&:hover, &:focus': {
      color: theme('colors.green1.15'),
    },

    '&:active': {
      color: theme('colors.green1.20'),
    },

    '&.disabled': {
      color: theme('colors.green1.40'),
    },
  },

  // Ensure we're also overriding default anchor element styles
  '.btn-text-light-noicon': {
    textDecoration: `underline solid ${theme('colors.green1.10')}`,
    textDecorationThickness: '2px',
    textUnderlineOffset: '3px',
    textDecorationSkipInk: 'none',
    // textDecorationThickness is not included in height,
    // so other elements may clip the text decoration without this extra margin
    marginBottom: '1px',

    '&:hover, &:focus': {
      textDecoration: `underline solid ${theme('colors.green1.15')}`,
      textDecorationThickness: '2px',
    },

    '&:active': {
      textDecoration: `underline solid ${theme('colors.green1.20')}`,
      textDecorationThickness: '2px',
    },

    '&.disabled': {
      color: theme('colors.green1.40'),
      textDecoration: `underline solid ${theme('colors.green1.40')}`,
      textDecorationThickness: '2px',
    },
  },
  '.btn-text-banner': {
    color: theme('colors.orange1.23'),

    '&:hover, &:focus': {
      color: theme('colors.orange1.15'),
    },

    '&:active': {
      color: theme('colors.orange1.15'),
    },

    '&.disabled': {
      color: theme('colors.orange1.30'),
    },
  },

  // Ensure we're also overriding default anchor element styles
  '.btn-text-banner-noicon': {
    textDecoration: `underline solid ${theme('colors.orange1.23')}`,
    textDecorationThickness: '2px',
    textUnderlineOffset: '3px',
    textDecorationSkipInk: 'none',
    // textDecorationThickness is not included in height,
    // so other elements may clip the text decoration without this extra margin
    marginBottom: '1px',

    '&:hover, &:focus': {
      textDecoration: `underline solid ${theme('colors.orange1.15')}`,
      textDecorationThickness: '2px',
    },

    '&:active': {
      textDecoration: `underline solid ${theme('colors.orange1.15')}`,
      textDecorationThickness: '2px',
    },

    '&.disabled': {
      color: theme('colors.green1.40'),
      textDecoration: `underline solid ${theme('colors.orange1.30')}`,
      textDecorationThickness: '2px',
    },
  },
});

module.exports = { textButtonStyles };
